/**
 * ResponsavelAssociado
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseExclude, ResponseSerialize} from 'simpli-web-sdk'
import {Responsavel} from '@/model/resource/Responsavel'
import {ResponsavelAssociadoCollection} from '@/model/collection/ResponsavelAssociadoCollection'

/* TODO: review generated class */
export class ResponsavelAssociado extends Resource {
  idAssociadoPk: number = 0

  @ResponseSerialize(Responsavel)
  responsavel: Responsavel | null = null

  razaoSocial: string | null = null
  nomeFantasia: string | null = null
  cnpj: string | null = null
  ativo: boolean | null = null

  @ResponseExclude()
  senha: string | null = null

  get $id() {
    return this.idAssociadoPk
  }
  set $id(val) {
    this.idAssociadoPk = val
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(val) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = val
  }

  /**
   * Gets a instance of a given ID of ResponsavelAssociado
   */
  async getResponsavelAssociado(id: number) {
    return await Request.get(`/admin/responsavel-associado/${id}`)
      .name('getResponsavelAssociado')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of ResponsavelAssociado
   */
  async removeResponsavelAssociado() {
    return await Request.delete(`/admin/responsavel-associado/${this.$id}`)
      .name('removeResponsavelAssociado')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelAssociado
   */
  static async listResponsavelAssociado(params: any) {
    return await Request.get(`/admin/responsavel-associado`, {params})
      .name('listResponsavelAssociado')
      .as(ResponsavelAssociadoCollection)
      .getData()
  }

  /**
   * Persists a new instance of ResponsavelAssociado. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavelAssociado() {
    return await Request.post(`/admin/responsavel-associado`, this)
      .name('persistResponsavelAssociado')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ResponsavelAssociado to use it in a CSV file
   */
  static async listCsvResponsavelAssociado(params: any) {
    return await Request.get(`/admin/responsavel-associado/csv`, {params})
      .name('listCsvResponsavelAssociado')
      .as(ResponsavelAssociadoCollection)
      .getData()
  }
}
